import React, { useCallback, useEffect, useState } from 'react';

// DevExtreme components
import { custom } from 'devextreme/ui/dialog';
import { Popup } from 'devextreme-react/popup';
import Tabs, { Item } from 'devextreme-react/tabs';
import { SelectBox, Button } from 'devextreme-react';
import DataGrid, { Column, Label } from 'devextreme-react/data-grid';
import Form, { SimpleItem, GroupItem } from "devextreme-react/form";

// Mock data and styles
import './gestion-points-vente.css';
import RenderBox from './render-items';
import useApi from '../../hooks/useApi';
//import { labelModes, columnsPopUp } from './fakeData';
import { PointVenteTypes, SommaireType, TotalMontantType } from './type';

const GestionPointsVente = () => {
  const { getData: getPointVente } = useApi();
  const { postData: postMontant } = useApi("Facturation/FacturationPointVenteCalCulMontant");

  // State definitions
  const [dataSourcePos, setDataSourcePos] = useState<PointVenteTypes[]>([]);
  const [dataSourceVisiteur, setDataSourceVisiteur] = useState<PointVenteTypes[]>([]);
  const [counter, setCount] = useState<Record<string, number>>({});
  const [labelMode, setLabelMode] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isPopupVisible, setPopupVisibility] = useState(false);
  const [dataSourceSommaire, setDataSourceSommaire] = useState<SommaireType[]>([]);
  const [montant, setMontant] = useState<TotalMontantType>({});

  // Fetch data on component mount and tab change
  useEffect(() => {
    getPointsVente();
  }, [selectedIndex]);

  // Method to handle tab selection change
  const onTabsSelectionChanged = (args: any) => {
    if (args?.name === 'selectedIndex') {
      setSelectedIndex(args?.value);
    }
  };

  //Method for get points of sale
  const getPointsVente = async () => {
    const resultPos = await getPointVente({ customPath: 'Catalogue/pointVentePos' });
    if (Array.isArray(resultPos)) setDataSourcePos(resultPos);

    const resultVente = await getPointVente({ customPath: 'Catalogue/pointVenteVisiteur' });
    if (Array.isArray(resultVente)) setDataSourceVisiteur(resultVente);
  };

  //Method reset all data in the forms
  const resetData = useCallback(() => {
    if (dataSourceSommaire.length > 0) {
      let myDialog = custom({
        dragEnabled: true,
        title: "Facture en cours",
        messageHtml: "La facture en cours n'a pas été payée et sera annulée.\nÊtes-vous sûr de vouloir continuer ?",
        buttons: [{
          text: "Oui",
          onClick: (e) => {
            return { buttonText: e.component.option("text") }
          }
        }, {
          text: "Non",
          onClick: (e) => {
            return { buttonText: e.component.option("text") }
          }
        }]
      });

      myDialog.show().then(async (dialogResult: any) => {
        if (dialogResult.buttonText == "Oui") {
          setCount({});
          setMontant({});
          setDataSourceSommaire([])
        }
      });
    }
  }, [dataSourceSommaire]);

  //Method handles changes to a counter
  const handleCounterChange = (id: string, value: number) => {
    //mise a jour de l'etat du conteur
    setCount(prevCounter => {
      //creation d'un nouvel objet de compteur avec la valeur mise a jour pour l"ID donne.
      const newCounter = {
        ...prevCounter,
        [id]: (prevCounter[id] || 0) + value // incrementation
      }
      //mise a jour du sommaire
      updateArraySommaire(newCounter)
      return newCounter;
    });
  };


  //Method to updates thes summary
  const updateArraySommaire = (newCounter: Record<string, number>) => {
    const newDataSommaire: SommaireType[] = [];
    //Combiner les deux tableaux de Pos et Visiteur
    const allDataSources = [dataSourcePos, dataSourceVisiteur];
    //iteration
    allDataSources.forEach((dataSource, tabIndex) => {
      dataSource.forEach((product) => {
        //Genere une cle unique pour chaque element (Utile pour le DataSource de la DataGrid dans Sommaire) 
        const key = `${tabIndex}_${product.idProduit}`;
        //Si le compteur pour cette cle existe et n'est pas a zero, ajout le au sommaire
        if (newCounter[key] && newCounter[key] !== 0) {
          newDataSommaire.push({
            ID: key,
            IdProduit: product?.idProduit ?? "",
            Quantite: newCounter[key], // la quantite est fonction du compteur
            Description: product?.description ?? "",
            Montant: product.prixVente ?? 0
          })
        }
      })
    });
    // met a jour la liste du sommaire
    setDataSourceSommaire(newDataSommaire);

    //L'envoie au back-end
    try {
      const newArryParams = newDataSommaire.map((elem) => {
        const { ID, ...newObjet } = elem; // Supprime la cle unique avant l'envoie au back-end
        return newObjet;
      })

      //Appel API
      postMontant(newArryParams)
        .then((result: any) => {
          if (result) setMontant(result) // met ajour les details sur le montant
        })
        .catch(err => {
          console.log('gestion Pos de Visiteur, une exception a ete leve', err)
        })
    } catch (error) {
      console.log('gestion Pos de Visiteur, une exception a ete leve', error)
    }
  }

  const onLabelModeChanged = (e: any) => {
    setLabelMode(e?.value);
  };

  const togglePopup = () => {
    setPopupVisibility(!isPopupVisible);
  };

  const renderContentPopUp = () => (
    <div className='wrapper-content-pop'>
      <DataGrid
        keyExpr="ID"
        dataSource={[]}
        showBorders={true}
        defaultColumns={['Client', 'Unite', 'Telephone', 'Vehicule', 'Plaque', 'Expiration', 'Mise en Depart']}
      />
      <div className='content-footer-pop'>
        <div className='content-footer-pop-left'>
          <Button text="Visiteurs Actifs" type="normal" />
          <Button text="Historiques" type="normal" />
        </div>
        <div className='content-footer-pop-right'>
          <Button text="Fermer" type="normal" onClick={togglePopup} />
        </div>
      </div>
    </div>
  );

  return (
    <div className='global-content'>
      <div className='wrapper-content'>
        <div id="wrapper-tabs">
          <div className='tabs'>
            <Tabs
              width={300}
              selectedIndex={selectedIndex}
              onOptionChanged={onTabsSelectionChanged}
            >
              <Item
                text="Pos"
              >
              </Item>
              <Item
                text="Visiteurs"
              >
              </Item>
            </Tabs>
          </div>
          <div className='wrapper-content-box'>
            {(selectedIndex === 0 ? dataSourcePos : dataSourceVisiteur).map((data, index) => {
              const uniqueKey = `${selectedIndex}_${data.idProduit}`;
              return (
                <RenderBox
                  key={uniqueKey}
                  id={uniqueKey}
                  title={data?.description ?? ""}
                  amount={data?.prixVente ?? 0}
                  count={counter[uniqueKey] || 0}
                  onCountChange={handleCounterChange}
                />
              );
            })}
          </div>
        </div>
        <div id="siderbar">
          <Form colCount={1} id="form" formData={[]}>
            <GroupItem caption="Contrôle" cssClass="bg-group">
              <Button text="Nouvelle Facture" type="normal" onClick={() => resetData()} />
            </GroupItem>
            <GroupItem caption="Paiement" cssClass="bg-group">
              <Button text="Paiement" type="normal" />
            </GroupItem>
            {selectedIndex == 1 && <GroupItem cssClass="bg-group">
              <GroupItem caption="Site">
                <SelectBox items={['outside', 'static', 'floating', 'hidden']} value={labelMode} onValueChanged={onLabelModeChanged} />
              </GroupItem>
              <GroupItem>
                <SimpleItem dataField="Nom" cssClass={"styleItem"} />
                <SimpleItem dataField="Prénom" cssClass={"styleItem"} />
                <SimpleItem dataField="Véhicule" cssClass={"styleItem"} />
                <SimpleItem dataField="Plaque" cssClass={"styleItem"} />
                <SimpleItem dataField="Date de début" editorType="dxDateBox" cssClass={"styleItem"} />
                <SimpleItem dataField="Date de fin" editorType="dxDateBox" cssClass={"styleItem"} />
                <SimpleItem dataField="Nombre d'heures tampon" editorType="dxNumberBox" cssClass={"styleItem"} />
              </GroupItem>
            </GroupItem>}
          </Form>
          <Form colCount={1} id="form" formData={[]}>
            <GroupItem caption="Sommaire" cssClass="bg-group">
              <GroupItem>
                <DataGrid
                  keyExpr="ID"
                  showBorders={true}
                  dataSource={dataSourceSommaire}
                >
                  <Column dataField='Quantite' dataType='number' caption='Qte' alignment='left' width={30} />
                  <Column dataField='Description' dataType='string' caption='Description' />
                  <Column dataField='Montant' dataType='number' caption='Montant' />
                </DataGrid>
              </GroupItem>
            </GroupItem>
          </Form>
          <Form colCount={1} id="form" formData={montant}>
            <GroupItem cssClass="bg-group">
              <SimpleItem dataField="montantAvantTaxes" cssClass={"styleItem"}>
                <Label text="Sous total" />
              </SimpleItem>
              <SimpleItem dataField="tps" cssClass={"styleItem"}>
                <Label text='TPS' />
              </SimpleItem>
              <SimpleItem dataField="tvq" cssClass={"styleItem"}>
                <Label text='TVQ' />
              </SimpleItem>
              <SimpleItem dataField="total" cssClass={"styleItem"}>
                <Label text='Total' />
              </SimpleItem>
            </GroupItem>
          </Form>
        </div>
      </div>
      <div className='footer-cta'>
        <Button text="Liste des visiteurs" type="normal" onClick={togglePopup} />
      </div>
      <Popup
        showTitle={true}
        title="Liste des visiteurs"
        visible={isPopupVisible}
        hideOnOutsideClick={true}
        contentRender={renderContentPopUp}
      />
    </div>
  );
}

export default GestionPointsVente